import React from 'react';
import { PillWithIcon } from '@els/els-react--pill';

function SummarySection({ children, ...rest }) {
  return (
    <section className="ai-search-summary u-els-margin-top u-els-margin-bottom u-els-padding" {...rest}>
      <h2 className="u-els-margin-bottom">
        <span className="u-els-font-size-h3 u-els-font-family-bold">Summary</span>
        <PillWithIcon
          iconProps={{
            sprite: 'AI',
          }}
          iconColor="text"
          iconRight
          pillColor="extended-blue-0"
          textColor="text"
          className="u-els-font-size-meta u-els-margin-left-1o4 ai-search-summary__ai-pill">
          AI
        </PillWithIcon>
      </h2>
      {children}
    </section>
  );
}

export default SummarySection;
